import script from "./OrderApproval.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderApproval.vue?vue&type=script&setup=true&lang=ts"

import "./OrderApproval.vue?vue&type=style&index=0&id=54d38a5e&lang=css"

const __exports__ = script;

export default __exports__